import { match, P } from 'ts-pattern';

import type { SubscriptionMe } from '@/entities/subscription';
import { formatCurrencyFromCents } from '@/shared/lib/format-utils';
import { formatShortDate } from '@/shared/lib/time-utils';

import type { BillingStatus } from './get-billing-status';

export const formatBillingStatusLine = (
    status: BillingStatus,
    {
        nextBillTotalCents,
        nextInvoiceAt,
        canceledAt,
        currentPeriodEnd,
    }: Pick<
        SubscriptionMe,
        'nextBillTotalCents' | 'nextInvoiceAt' | 'canceledAt' | 'currentPeriodEnd'
    >,
): string | null =>
    match(status)
        .with(P.union('active', 'past-due'), () =>
            typeof nextBillTotalCents === 'number' && typeof nextInvoiceAt === 'string'
                ? `Your next bill is for ${formatCurrencyFromCents(nextBillTotalCents)} on ${formatShortDate(nextInvoiceAt)}`
                : null,
        )
        // A cancellation scheduled for the end of the period lands on the period's own end date.
        .with('cancelling', () =>
            currentPeriodEnd
                ? `Your plan will be canceled on ${formatShortDate(currentPeriodEnd)}`
                : null,
        )
        // Subscriptions canceled before the date was recorded keep a complete sentence rather
        // than losing the line entirely (FR-009's treatment of an unknown card expiry).
        .with('canceled', () =>
            canceledAt
                ? `Your plan was canceled on ${formatShortDate(canceledAt)}`
                : 'Your plan was canceled',
        )
        .exhaustive();
